export const FILE_CHAT_EVENTS = {
  complete: [
    'file.chat.answer.complete',
    'file-chat.chat.complete',
    'file-chat.complete',
    'file.chat.complete',
  ],
  error: [
    'file.chat.answer.error',
    'file-chat.chat.error',
    'file-chat.error',
    'file.chat.error',
  ],
};
